import { render } from "./contact-link.vue?vue&type=template&id=b7b52784&scoped=true&ts=true"
import script from "./contact-link.vue?vue&type=script&lang=ts"
export * from "./contact-link.vue?vue&type=script&lang=ts"

import "./contact-link.vue?vue&type=style&index=0&id=b7b52784&lang=scss&scoped=true"

import exportComponent from "E:\\Build\\vsts-agent-win-x64-4.268.0\\_work\\2\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7b52784"]])

export default __exports__